import axios from 'axios'
import types from './types'
import { showNotification } from './notifications'

axios.defaults.withCredentials = true

export function loadEnterprise (id) {
  return (dispatch) => {
    return dispatch({
      type: types.LOAD_ENTERPRISE,
      payload: axios.get(`${process.env.REACT_APP_IDENTITY_API_HOST}/v1/enterprises/${id}`)
    }).then(data => data)
  }
}

export function addEnterprise (data) {
  return (dispatch) => {
    return dispatch({
      type: types.ADD_ENTERPRISE,
      payload: axios.post(`${process.env.REACT_APP_IDENTITY_API_HOST}/v1/enterprises`, data)
    }).then(data => {
      dispatch(showNotification('Enterprise added successfully'))
    })
  }
}

export function updateEnterprise (id, data) {
  return (dispatch) => {
    return dispatch({
      type: types.UPDATE_ENTERPRISE,
      payload: axios.put(`${process.env.REACT_APP_IDENTITY_API_HOST}/v1/enterprises/${id}`, data),
      meta: { data }
    }).then(data => {
      dispatch(showNotification('Enterprise updated successfully'))
    })
  }
}

export function addEnterpriseDomain (id, data) {
  return (dispatch) => {
    return dispatch({
      type: types.ADD_ENTERPRISE_DOMAIN,
      payload: axios.post(`${process.env.REACT_APP_IDENTITY_API_HOST}/v1/enterprises/${id}/domains`, data)
    }).then(data => {
      dispatch(showNotification('Domain added successfully'))
    }).catch(err => {
      if (err) {
        console.error(err.response.data)
        dispatch(showNotification(`Error: ${err.response.data.message}.`))
      }
    })
  }
}

export function fetchRemoteMetadataForDomain (index, url) {
  return (dispatch) => {
    return dispatch({
      type: types.FETCH_ENTERPRISE_DOMAIN_SAML_METADATA,
      payload: axios.get(`${process.env.REACT_APP_IDENTITY_API_HOST}/auth/saml/remote/metadata`, { params: { url } }),
      meta: { index }
    }).then(data => data)
  }
}

export function loadEnterpriseUsers (id, data) {
  return (dispatch) => {
    return dispatch({
      type: types.FETCH_ENTERPRISE_USERS,
      payload: axios.get(`${process.env.REACT_APP_IDENTITY_API_HOST}/v1/enterprises/${id}/users`, data),
      meta: { data }
    }).then(data => data)
  }
}

export function updateEnterpriseUser (enterpriseId, userId, data) {
  return (dispatch) => {
    return dispatch({
      type: types.UPDATE_ENTERPRISE_USER,
      payload: axios.put(`${process.env.REACT_APP_IDENTITY_API_HOST}/v1/enterprises/${enterpriseId}/users/${userId}`, data),
      meta: { data }
    }).then(data => {
      if (data.action.payload.data.tempPassword) {
        dispatch(showNotification(`Password: ${data.action.payload.data.tempPassword} (CLICK TO COPY)`))
      }
    })
  }
}

// @todo change api naming
export function claimEnterpriseUsers (enterpriseId, domainId, data) {
  return (dispatch) => {
    return dispatch({
      type: types.CLAIM_ENTERPRISE_USERS,
      payload: axios.get(`${process.env.REACT_APP_IDENTITY_API_HOST}/v1/enterprises/${enterpriseId}/domains/${domainId}/users/claim`, data),
      meta: { data }
    }).then(data => data)
  }
}

// @todo change api naming
export function forceSamlOnEnterpriseUsers (enterpriseId, domainId, data) {
  return (dispatch) => {
    return dispatch({
      type: types.FORCE_SAML_ON_ENTERPRISE_USERS,
      payload: axios.get(`${process.env.REACT_APP_IDENTITY_API_HOST}/v1/enterprises/${enterpriseId}/domains/${domainId}/users/forceSaml`, data),
      meta: { data }
    }).then(data => data)
  }
}

export function updateSSOForEnterpriseDomain (enterpriseid, domainid, data) {
  return (dispatch) => {
    return dispatch({
      type: types.UPDATE_ENTERPRISE_DOMAIN_SAML,
      payload: axios.post(`${process.env.REACT_APP_IDENTITY_API_HOST}/v1/enterprises/${enterpriseid}/domains/${domainid}/saml`, data),
      meta: { data }
    }).then(data => data)
  }
}
